export const SHOW_CONFIRM_DIALOG = 'SHOW_CONFIRM_DIALOG';
export const HIDE_CONFIRM_DIALOG = 'HIDE_CONFIRM_DIALOG';


